// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

.flex-column {
	display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
	flex-grow: 0;
}
.flex-row {
	display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
	flex-grow: 0;
}
.login {
  width: 30vw;
  padding: 2rem;
  background-color: #ebf8ff;
}
@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}


/*
 ██████  ██       ██████  ██████   █████  ██           ██████ ██       █████  ███████ ███████ ███████ ███████ 
██       ██      ██    ██ ██   ██ ██   ██ ██          ██      ██      ██   ██ ██      ██      ██      ██      
██   ███ ██      ██    ██ ██████  ███████ ██          ██      ██      ███████ ███████ ███████ █████   ███████ 
██    ██ ██      ██    ██ ██   ██ ██   ██ ██          ██      ██      ██   ██      ██      ██ ██           ██ 
 ██████  ███████  ██████  ██████  ██   ██ ███████      ██████ ███████ ██   ██ ███████ ███████ ███████ ███████ 
*/
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.ag-cell:focus {
  outline: none !important;
  border: none !important;
  box-shadow: none !important;
}
/* LOADING INDICATOR */
.loading-indicator {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  padding: 10px;
  color: #fff;
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 5px;
  z-index:1000;
}
.spinner {
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid white;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin-top: 120px;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.default-button {
  padding: 10px;
  width: auto;
  background-color: #4e79a7;
  color: white;
  border-radius: 0.375rem;
  cursor: pointer;
  flex-shrink: 0; /* Ne zsugorodjon, ha kevés a hely */
  font-size: 12px;
}

.default-button:hover {
  background-color: #2c5675;
}

.default-select {
  width: 100%;              /* megegyezzen az input szélességével */
  padding: 0.5rem 0.75rem;  /* ugyanaz, mint az input */
  font-size: 0.875rem;      /* text-sm */
  font-weight: 500;          /* font-medium */
  color: #1e40af;           /* text-blue-800 */
  border: 1px solid #3b82f6; /* input border szín */
  border-radius: 0.375rem;  /* 2xl kerekítés a példa szerint */
  background-color: white;
}

.default-select:focus {
  outline: none;
  border-color: #1e40af;     /* fókusz szín */
  box-shadow: 0 0 0 1px #1e40af;
}

/*
 ============================================================================
 VOXDOC DESIGN CSS CLASSES (from !design folder)
 Prefix: vd- to avoid conflicts with existing classes
 ============================================================================
*/

/* Design Tokens */
:root {
  --vd-blue-800: #0F3F66;
  --vd-blue-700: #155489;
  --vd-blue-600: #1C6BB0;
  --vd-blue-500: #2E86CE;
  --vd-blue-200: #B7D3EA;
  --vd-blue-100: #D6E6F2;
  --vd-blue-50: #EAF2F9;
  --vd-ink: #15212B;
  --vd-muted: #5C6E7D;
  --vd-muted-2: #8395A3;
  --vd-line: #E4EAF0;
  --vd-line-soft: #EFF3F7;
  --vd-bg: #F1F5F9;
  --vd-surface: #fff;
  --vd-coral: #DB5B57;
  --vd-danger: #C2453F;
  --vd-danger-bg: #FBECEB;
  --vd-green: #1F8A5B;
  --vd-green-bg: #E6F4EC;
  --vd-amber: #B7791F;
  --vd-amber-bg: #FBF1DD;
  font-family: 'IBM Plex Sans', system-ui, sans-serif;
}

/* Window shell */
.vd-wapp {
  position: fixed;
  inset: 0;
  display: flex;
  flex-direction: column;
  background: var(--vd-bg);
  color: var(--vd-ink);
  overflow: hidden;
}

.vd-wtitle {
  height: 56px;
  flex: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px 0 18px;
  background: var(--vd-surface);
  border-bottom: 1px solid var(--vd-line);
}

.vd-wtitle__ctrls {
  display: flex;
  align-items: center;
  gap: 2px;
}

.vd-wctrl {
  width: 34px;
  height: 30px;
  border: none;
  background: transparent;
  border-radius: 7px;
  color: var(--vd-muted);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all .12s;
}

.vd-wctrl:hover {
  background: var(--vd-line-soft);
  color: var(--vd-ink);
}

.vd-wctrl--close:hover {
  background: var(--vd-coral);
  color: #fff;
}

.vd-wbody {
  flex: 1 1;
  min-height: 0;
  display: flex;
}

/* Sidebar */
.vd-wside {
  width: 270px;
  flex: none;
  background: var(--vd-surface);
  border-right: 1px solid var(--vd-line);
  padding: 16px 8px 16px 14px;
  overflow-y: auto;
}

.vd-wgrp {
  margin-top: 16px;
}

.vd-wgrp__label {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: .09em;
  text-transform: uppercase;
  color: var(--vd-muted-2);
  padding: 0 12px 6px;
}

.vd-wnav {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  height: 44px;
  padding: 0 12px;
  border: none;
  border-radius: 10px;
  background: transparent;
  color: var(--vd-ink);
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  text-align: left;
  transition: all .12s;
}

.vd-wnav__ico {
  display: flex;
  flex: none;
  color: var(--vd-muted);
  transition: color .12s;
}

.vd-wnav__txt {
  flex: 1 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.vd-wnav:hover {
  background: var(--vd-blue-50);
  color: var(--vd-blue-700);
}

.vd-wnav:hover .vd-wnav__ico {
  color: var(--vd-blue-600);
}

.vd-wnav--on {
  background: var(--vd-blue-50);
  color: var(--vd-blue-700);
  font-weight: 600;
}

.vd-wnav--on .vd-wnav__ico {
  color: var(--vd-blue-600);
}

.vd-wnav__bar {
  position: absolute;
  left: -14px;
  top: 9px;
  bottom: 9px;
  width: 3px;
  border-radius: 0 3px 3px 0;
  background: var(--vd-blue-600);
}

/* Dictate / record pill */
.vd-recpill {
  height: 42px;
  padding: 0 18px 0 14px;
  border: none;
  border-radius: 11px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  background: var(--vd-blue-600);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  font-family: inherit;
  box-shadow: 0 2px 8px rgba(28,107,176,.28);
  transition: all .15s;
  white-space: nowrap;
}

.vd-recpill:hover {
  background: var(--vd-blue-700);
}

.vd-recpill--big {
  width: 100%;
  height: 52px;
  justify-content: flex-start;
  font-size: 16px;
  padding-left: 18px;
  border-radius: 12px;
}

.vd-recpill__icon {
  display: flex;
}

.vd-recpill__ring {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2.5px solid #fff;
}

.vd-recpill--on {
  background: var(--vd-coral);
  box-shadow: 0 2px 10px rgba(219,91,87,.35);
}

.vd-recpill__rec {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  animation: vd-pulse 1.1s ease-in-out infinite;
}

.vd-recpill--new {
  padding-left: 16px;
}

@keyframes vd-pulse {
  0%,100% { opacity: 1; transform: scale(1); }
  50% { opacity: .45; transform: scale(.8); }
}

/* Main content area */
.vd-wmain {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

/* View header */
.vd-vhead {
  flex: none;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding: 26px 30px 18px;
}

.vd-vhead__title {
  font-size: 25px;
  font-weight: 700;
  margin: 0;
  letter-spacing: -.02em;
}

.vd-vhead__sub {
  margin: 3px 0 0;
  font-size: 14px;
  color: var(--vd-muted);
}

.vd-vscroll {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding: 0 30px 28px;
}

/* Segmented control */
.vd-segctl {
  display: flex;
  background: var(--vd-line-soft);
  border-radius: 10px;
  padding: 3px;
  gap: 2px;
}

.vd-segctl button {
  height: 34px;
  padding: 0 16px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: var(--vd-muted);
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all .12s;
}

.vd-segctl button.vd-segctl--on {
  background: var(--vd-surface);
  color: var(--vd-blue-700);
  box-shadow: 0 1px 3px rgba(0,0,0,.08);
}

/* Settings card */
.vd-setcard {
  background: var(--vd-surface);
  border: 1px solid var(--vd-line);
  border-radius: 14px;
  padding: 8px 18px 14px;
}

.vd-setcard__h {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: .08em;
  text-transform: uppercase;
  color: var(--vd-muted-2);
  padding: 14px 0 10px;
  border-bottom: 1px solid var(--vd-line-soft);
  margin-bottom: 6px;
}

.vd-setrow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  min-height: 48px;
  padding: 5px 0;
}

.vd-setrow__lbl {
  font-size: 14.5px;
  color: var(--vd-ink);
}

.vd-setrow--about .vd-setrow__lbl {
  color: var(--vd-muted);
}

.vd-setrow__val {
  font-size: 14px;
  color: var(--vd-blue-700);
  font-weight: 500;
}

/* Switch toggle */
.vd-swtoggle {
  width: 46px;
  height: 26px;
  flex: none;
  border: none;
  border-radius: 999px;
  background: var(--vd-line);
  cursor: pointer;
  position: relative;
  transition: background .16s;
  padding: 0;
}

.vd-swtoggle--on {
  background: var(--vd-blue-600);
}

.vd-swtoggle__knob {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0,0,0,.2);
  transition: left .16s;
}

.vd-swtoggle--on .vd-swtoggle__knob {
  left: 23px;
}

/* Stepper */
.vd-stepper {
  display: flex;
  align-items: center;
  gap: 2px;
  background: var(--vd-line-soft);
  border-radius: 9px;
  padding: 3px;
}

.vd-stepper button {
  width: 30px;
  height: 28px;
  border: none;
  background: transparent;
  border-radius: 7px;
  color: var(--vd-muted);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all .12s;
}

.vd-stepper button:hover {
  background: var(--vd-surface);
  color: var(--vd-blue-700);
}

.vd-stepper__v {
  min-width: 54px;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
}

/* Select field */
.vd-selfield {
  position: relative;
  display: flex;
  align-items: center;
}

.vd-selfield select {
  appearance: none;
  height: 38px;
  padding: 0 34px 0 13px;
  border: 1px solid var(--vd-line);
  border-radius: 9px;
  background: var(--vd-line-soft);
  font-family: inherit;
  font-size: 14px;
  color: var(--vd-ink);
  font-weight: 500;
  cursor: pointer;
  min-width: 120px;
}

.vd-selfield svg {
  position: absolute;
  right: 11px;
  color: var(--vd-muted-2);
  pointer-events: none;
}

/* Search field */
.vd-lsearch {
  display: flex;
  align-items: center;
  gap: 9px;
  height: 40px;
  padding: 0 13px;
  background: var(--vd-surface);
  border: 1px solid var(--vd-line);
  border-radius: 10px;
  color: var(--vd-muted-2);
  transition: border-color .13s;
}

.vd-lsearch:focus-within {
  border-color: var(--vd-blue-200);
}

.vd-lsearch svg {
  flex: none;
}

.vd-lsearch input {
  border: none;
  outline: none;
  background: transparent;
  font-family: inherit;
  font-size: 13.5px;
  color: var(--vd-ink);
  width: 100%;
}

.vd-lsearch input::placeholder {
  color: var(--vd-muted-2);
}

.vd-lsearch--sm {
  height: 38px;
}

.vd-lsearch--sm input {
  font-size: 13px;
}

/* Tooltip */
.vd-tipwrap {
  position: relative;
  display: inline-flex;
}

.vd-tipwrap::after {
  content: attr(data-tip);
  position: absolute;
  z-index: 90;
  left: 50%;
  transform: translateX(-50%) translateY(4px);
  background: var(--vd-ink);
  color: #fff;
  font-size: 11.5px;
  font-weight: 500;
  padding: 6px 9px;
  border-radius: 7px;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  transition: opacity .12s .25s, transform .12s .25s;
  box-shadow: 0 6px 18px rgba(0,0,0,.18);
}

.vd-tipwrap--bottom::after {
  top: 100%;
}

.vd-tipwrap--top::after {
  bottom: 100%;
  transform: translateX(-50%) translateY(-4px);
}

.vd-tipwrap:hover::after {
  opacity: 1;
  transform: translateX(-50%) translateY(8px);
}

.vd-tipwrap--top:hover::after {
  opacity: 1;
  transform: translateX(-50%) translateY(-8px);
}

/* Toast */
.vd-wtoast {
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 11px 18px;
  background: var(--vd-ink);
  color: #fff;
  border-radius: 11px;
  font-size: 13.5px;
  font-weight: 500;
  box-shadow: 0 10px 30px rgba(0,0,0,.25);
  z-index: 200;
  animation: vd-toastin .2s ease;
}

.vd-wtoast svg {
  color: #5FD0A0;
}

@keyframes vd-toastin {
  from { opacity: 0; transform: translateX(-50%) translateY(8px); }
  to { opacity: 1; transform: translateX(-50%) translateY(0); }
}

/* Input field */
.vd-winput {
  height: 44px;
  padding: 0 14px;
  border: 1px solid var(--vd-line);
  border-radius: 10px;
  background: var(--vd-surface);
  font-family: inherit;
  font-size: 14.5px;
  color: var(--vd-ink);
  outline: none;
  transition: border-color .13s;
}

.vd-winput:focus {
  border-color: var(--vd-blue-200);
}

.vd-winput--mono {
  font-family: 'IBM Plex Mono', monospace;
  font-size: 13.5px;
}

/* Field wrapper */
.vd-wfield {
  display: flex;
  flex-direction: column;
  gap: 7px;
  margin-bottom: 16px;
}

.vd-wfield__lbl {
  font-size: 13px;
  font-weight: 600;
  color: var(--vd-muted);
}

.vd-wfield__tag {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: .05em;
  text-transform: uppercase;
  color: var(--vd-amber);
  background: var(--vd-amber-bg);
  padding: 2px 7px;
  border-radius: 999px;
  margin-left: 6px;
}

.vd-wfield__box {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 11px 13px;
  background: var(--vd-line-soft);
  border-radius: 10px;
  font-family: 'IBM Plex Mono', monospace;
  font-size: 14px;
  color: var(--vd-ink);
}

.vd-wfield__box svg {
  color: var(--vd-blue-500);
  flex: none;
}

.vd-wfield__hint {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--vd-muted-2);
}

.vd-wfield__hint svg {
  color: var(--vd-blue-500);
}

/* Button */
.vd-ebtn {
  height: 44px;
  padding: 0 18px;
  border-radius: 11px;
  border: 1px solid var(--vd-line);
  background: var(--vd-surface);
  color: var(--vd-ink);
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all .13s;
}

.vd-ebtn--ghost:hover {
  background: var(--vd-line-soft);
}

.vd-ebtn--primary {
  background: var(--vd-blue-600);
  border-color: var(--vd-blue-600);
  color: #fff;
  box-shadow: 0 2px 8px rgba(28,107,176,.28);
}

.vd-ebtn--primary:hover {
  background: var(--vd-blue-700);
}

.vd-ebtn--danger {
  background: var(--vd-danger-bg);
  border-color: transparent;
  color: var(--vd-danger);
}

.vd-ebtn--danger:hover {
  background: var(--vd-danger);
  color: #fff;
}

.vd-ebtn--grow {
  flex: 1 1;
}

.vd-ebtn--icon {
  width: 48px;
  padding: 0;
  flex: none;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;CACC,aAAa;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;CACxB,YAAY;AACb;AACA;CACC,aAAa;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;CACxB,YAAY;AACb;AACA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;;AAGA;;;;;;CAMC;AACD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,2BAA2B;AAC7B;AACA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,0CAA0C;EAC1C,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,iBAAiB;AACnB;AACA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc,EAAE,oCAAoC;EACpD,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW,eAAe,uCAAuC;EACjE,uBAAuB,GAAG,2BAA2B;EACrD,mBAAmB,OAAO,YAAY;EACtC,gBAAgB,WAAW,gBAAgB;EAC3C,cAAc,YAAY,kBAAkB;EAC5C,yBAAyB,EAAE,sBAAsB;EACjD,uBAAuB,GAAG,kCAAkC;EAC5D,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qBAAqB,MAAM,gBAAgB;EAC3C,6BAA6B;AAC/B;;AAEA;;;;;CAKC;;AAED,kBAAkB;AAClB;EACE,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,mDAAmD;AACrD;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,6BAA6B;EAC7B,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;AACf;;AAEA,YAAY;AACZ;EACE,YAAY;EACZ,UAAU;EACV,6BAA6B;EAC7B,sCAAsC;EACtC,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,WAAW;EACX,UAAU;EACV,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA,0BAA0B;AAC1B;EACE,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,0CAA0C;EAC1C,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU,UAAU,EAAE,mBAAmB,EAAE;EAC3C,MAAM,YAAY,EAAE,oBAAoB,EAAE;AAC5C;;AAEA,sBAAsB;AACtB;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,UAAU;EACV,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA,kBAAkB;AAClB;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;EACxB,oBAAoB;EACpB,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,oBAAoB;EACpB,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,gCAAgC;EAChC,kBAAkB;EAClB,+BAA+B;EAC/B,oBAAoB;EACpB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,gCAAgC;EAChC,mBAAmB;EACnB,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2CAA2C;EAC3C,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,kDAAkD;EAClD,sCAAsC;AACxC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,UAAU;EACV,2CAA2C;AAC7C;;AAEA;EACE,UAAU;EACV,4CAA4C;AAC9C;;AAEA,UAAU;AACV;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,uCAAuC;EACvC,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,OAAO,UAAU,EAAE,2CAA2C,EAAE;EAChE,KAAK,UAAU,EAAE,yCAAyC,EAAE;AAC9D;;AAEA,gBAAgB;AAChB;EACE,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,uCAAuC;EACvC,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,uCAAuC;EACvC,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gCAAgC;EAChC,6BAA6B;EAC7B,oBAAoB;EACpB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,WAAW;EACX,UAAU;EACV,UAAU;AACZ","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n.flex-column {\n\tdisplay: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\tflex-grow: 0;\n}\n.flex-row {\n\tdisplay: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n\tflex-grow: 0;\n}\n.login {\n  width: 30vw;\n  padding: 2rem;\n  background-color: #ebf8ff;\n}\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n\n/*\n ██████  ██       ██████  ██████   █████  ██           ██████ ██       █████  ███████ ███████ ███████ ███████ \n██       ██      ██    ██ ██   ██ ██   ██ ██          ██      ██      ██   ██ ██      ██      ██      ██      \n██   ███ ██      ██    ██ ██████  ███████ ██          ██      ██      ███████ ███████ ███████ █████   ███████ \n██    ██ ██      ██    ██ ██   ██ ██   ██ ██          ██      ██      ██   ██      ██      ██ ██           ██ \n ██████  ███████  ██████  ██████  ██   ██ ███████      ██████ ███████ ██   ██ ███████ ███████ ███████ ███████ \n*/\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.4);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n.ag-cell:focus {\n  outline: none !important;\n  border: none !important;\n  box-shadow: none !important;\n}\n/* LOADING INDICATOR */\n.loading-indicator {\n  text-align: center;\n  font-size: 18px;\n  font-weight: bold;\n  padding: 10px;\n  color: #fff;\n  background: rgba(0, 0, 0, 0.7);\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  border-radius: 5px;\n  z-index:1000;\n}\n.spinner {\n  border: 4px solid rgba(255, 255, 255, 0.3);\n  border-top: 4px solid white;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  animation: spin 1s linear infinite;\n  margin-top: 120px;\n}\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.default-button {\n  padding: 10px;\n  width: auto;\n  background-color: #4e79a7;\n  color: white;\n  border-radius: 0.375rem;\n  cursor: pointer;\n  flex-shrink: 0; /* Ne zsugorodjon, ha kevés a hely */\n  font-size: 12px;\n}\n\n.default-button:hover {\n  background-color: #2c5675;\n}\n\n.default-select {\n  width: 100%;              /* megegyezzen az input szélességével */\n  padding: 0.5rem 0.75rem;  /* ugyanaz, mint az input */\n  font-size: 0.875rem;      /* text-sm */\n  font-weight: 500;          /* font-medium */\n  color: #1e40af;           /* text-blue-800 */\n  border: 1px solid #3b82f6; /* input border szín */\n  border-radius: 0.375rem;  /* 2xl kerekítés a példa szerint */\n  background-color: white;\n}\n\n.default-select:focus {\n  outline: none;\n  border-color: #1e40af;     /* fókusz szín */\n  box-shadow: 0 0 0 1px #1e40af;\n}\n\n/*\n ============================================================================\n VOXDOC DESIGN CSS CLASSES (from !design folder)\n Prefix: vd- to avoid conflicts with existing classes\n ============================================================================\n*/\n\n/* Design Tokens */\n:root {\n  --vd-blue-800: #0F3F66;\n  --vd-blue-700: #155489;\n  --vd-blue-600: #1C6BB0;\n  --vd-blue-500: #2E86CE;\n  --vd-blue-200: #B7D3EA;\n  --vd-blue-100: #D6E6F2;\n  --vd-blue-50: #EAF2F9;\n  --vd-ink: #15212B;\n  --vd-muted: #5C6E7D;\n  --vd-muted-2: #8395A3;\n  --vd-line: #E4EAF0;\n  --vd-line-soft: #EFF3F7;\n  --vd-bg: #F1F5F9;\n  --vd-surface: #fff;\n  --vd-coral: #DB5B57;\n  --vd-danger: #C2453F;\n  --vd-danger-bg: #FBECEB;\n  --vd-green: #1F8A5B;\n  --vd-green-bg: #E6F4EC;\n  --vd-amber: #B7791F;\n  --vd-amber-bg: #FBF1DD;\n  font-family: 'IBM Plex Sans', system-ui, sans-serif;\n}\n\n/* Window shell */\n.vd-wapp {\n  position: fixed;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  background: var(--vd-bg);\n  color: var(--vd-ink);\n  overflow: hidden;\n}\n\n.vd-wtitle {\n  height: 56px;\n  flex: none;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 10px 0 18px;\n  background: var(--vd-surface);\n  border-bottom: 1px solid var(--vd-line);\n}\n\n.vd-wtitle__ctrls {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.vd-wctrl {\n  width: 34px;\n  height: 30px;\n  border: none;\n  background: transparent;\n  border-radius: 7px;\n  color: var(--vd-muted);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all .12s;\n}\n\n.vd-wctrl:hover {\n  background: var(--vd-line-soft);\n  color: var(--vd-ink);\n}\n\n.vd-wctrl--close:hover {\n  background: var(--vd-coral);\n  color: #fff;\n}\n\n.vd-wbody {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n}\n\n/* Sidebar */\n.vd-wside {\n  width: 270px;\n  flex: none;\n  background: var(--vd-surface);\n  border-right: 1px solid var(--vd-line);\n  padding: 16px 8px 16px 14px;\n  overflow-y: auto;\n}\n\n.vd-wgrp {\n  margin-top: 16px;\n}\n\n.vd-wgrp__label {\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: .09em;\n  text-transform: uppercase;\n  color: var(--vd-muted-2);\n  padding: 0 12px 6px;\n}\n\n.vd-wnav {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  height: 44px;\n  padding: 0 12px;\n  border: none;\n  border-radius: 10px;\n  background: transparent;\n  color: var(--vd-ink);\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  text-align: left;\n  transition: all .12s;\n}\n\n.vd-wnav__ico {\n  display: flex;\n  flex: none;\n  color: var(--vd-muted);\n  transition: color .12s;\n}\n\n.vd-wnav__txt {\n  flex: 1;\n  min-width: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.vd-wnav:hover {\n  background: var(--vd-blue-50);\n  color: var(--vd-blue-700);\n}\n\n.vd-wnav:hover .vd-wnav__ico {\n  color: var(--vd-blue-600);\n}\n\n.vd-wnav--on {\n  background: var(--vd-blue-50);\n  color: var(--vd-blue-700);\n  font-weight: 600;\n}\n\n.vd-wnav--on .vd-wnav__ico {\n  color: var(--vd-blue-600);\n}\n\n.vd-wnav__bar {\n  position: absolute;\n  left: -14px;\n  top: 9px;\n  bottom: 9px;\n  width: 3px;\n  border-radius: 0 3px 3px 0;\n  background: var(--vd-blue-600);\n}\n\n/* Dictate / record pill */\n.vd-recpill {\n  height: 42px;\n  padding: 0 18px 0 14px;\n  border: none;\n  border-radius: 11px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: var(--vd-blue-600);\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n  font-family: inherit;\n  box-shadow: 0 2px 8px rgba(28,107,176,.28);\n  transition: all .15s;\n  white-space: nowrap;\n}\n\n.vd-recpill:hover {\n  background: var(--vd-blue-700);\n}\n\n.vd-recpill--big {\n  width: 100%;\n  height: 52px;\n  justify-content: flex-start;\n  font-size: 16px;\n  padding-left: 18px;\n  border-radius: 12px;\n}\n\n.vd-recpill__icon {\n  display: flex;\n}\n\n.vd-recpill__ring {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  border: 2.5px solid #fff;\n}\n\n.vd-recpill--on {\n  background: var(--vd-coral);\n  box-shadow: 0 2px 10px rgba(219,91,87,.35);\n}\n\n.vd-recpill__rec {\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  background: #fff;\n  animation: vd-pulse 1.1s ease-in-out infinite;\n}\n\n.vd-recpill--new {\n  padding-left: 16px;\n}\n\n@keyframes vd-pulse {\n  0%,100% { opacity: 1; transform: scale(1); }\n  50% { opacity: .45; transform: scale(.8); }\n}\n\n/* Main content area */\n.vd-wmain {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n/* View header */\n.vd-vhead {\n  flex: none;\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  padding: 26px 30px 18px;\n}\n\n.vd-vhead__title {\n  font-size: 25px;\n  font-weight: 700;\n  margin: 0;\n  letter-spacing: -.02em;\n}\n\n.vd-vhead__sub {\n  margin: 3px 0 0;\n  font-size: 14px;\n  color: var(--vd-muted);\n}\n\n.vd-vscroll {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 0 30px 28px;\n}\n\n/* Segmented control */\n.vd-segctl {\n  display: flex;\n  background: var(--vd-line-soft);\n  border-radius: 10px;\n  padding: 3px;\n  gap: 2px;\n}\n\n.vd-segctl button {\n  height: 34px;\n  padding: 0 16px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--vd-muted);\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all .12s;\n}\n\n.vd-segctl button.vd-segctl--on {\n  background: var(--vd-surface);\n  color: var(--vd-blue-700);\n  box-shadow: 0 1px 3px rgba(0,0,0,.08);\n}\n\n/* Settings card */\n.vd-setcard {\n  background: var(--vd-surface);\n  border: 1px solid var(--vd-line);\n  border-radius: 14px;\n  padding: 8px 18px 14px;\n}\n\n.vd-setcard__h {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: .08em;\n  text-transform: uppercase;\n  color: var(--vd-muted-2);\n  padding: 14px 0 10px;\n  border-bottom: 1px solid var(--vd-line-soft);\n  margin-bottom: 6px;\n}\n\n.vd-setrow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  min-height: 48px;\n  padding: 5px 0;\n}\n\n.vd-setrow__lbl {\n  font-size: 14.5px;\n  color: var(--vd-ink);\n}\n\n.vd-setrow--about .vd-setrow__lbl {\n  color: var(--vd-muted);\n}\n\n.vd-setrow__val {\n  font-size: 14px;\n  color: var(--vd-blue-700);\n  font-weight: 500;\n}\n\n/* Switch toggle */\n.vd-swtoggle {\n  width: 46px;\n  height: 26px;\n  flex: none;\n  border: none;\n  border-radius: 999px;\n  background: var(--vd-line);\n  cursor: pointer;\n  position: relative;\n  transition: background .16s;\n  padding: 0;\n}\n\n.vd-swtoggle--on {\n  background: var(--vd-blue-600);\n}\n\n.vd-swtoggle__knob {\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: #fff;\n  box-shadow: 0 1px 3px rgba(0,0,0,.2);\n  transition: left .16s;\n}\n\n.vd-swtoggle--on .vd-swtoggle__knob {\n  left: 23px;\n}\n\n/* Stepper */\n.vd-stepper {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  background: var(--vd-line-soft);\n  border-radius: 9px;\n  padding: 3px;\n}\n\n.vd-stepper button {\n  width: 30px;\n  height: 28px;\n  border: none;\n  background: transparent;\n  border-radius: 7px;\n  color: var(--vd-muted);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all .12s;\n}\n\n.vd-stepper button:hover {\n  background: var(--vd-surface);\n  color: var(--vd-blue-700);\n}\n\n.vd-stepper__v {\n  min-width: 54px;\n  text-align: center;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n/* Select field */\n.vd-selfield {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.vd-selfield select {\n  appearance: none;\n  height: 38px;\n  padding: 0 34px 0 13px;\n  border: 1px solid var(--vd-line);\n  border-radius: 9px;\n  background: var(--vd-line-soft);\n  font-family: inherit;\n  font-size: 14px;\n  color: var(--vd-ink);\n  font-weight: 500;\n  cursor: pointer;\n  min-width: 120px;\n}\n\n.vd-selfield svg {\n  position: absolute;\n  right: 11px;\n  color: var(--vd-muted-2);\n  pointer-events: none;\n}\n\n/* Search field */\n.vd-lsearch {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  height: 40px;\n  padding: 0 13px;\n  background: var(--vd-surface);\n  border: 1px solid var(--vd-line);\n  border-radius: 10px;\n  color: var(--vd-muted-2);\n  transition: border-color .13s;\n}\n\n.vd-lsearch:focus-within {\n  border-color: var(--vd-blue-200);\n}\n\n.vd-lsearch svg {\n  flex: none;\n}\n\n.vd-lsearch input {\n  border: none;\n  outline: none;\n  background: transparent;\n  font-family: inherit;\n  font-size: 13.5px;\n  color: var(--vd-ink);\n  width: 100%;\n}\n\n.vd-lsearch input::placeholder {\n  color: var(--vd-muted-2);\n}\n\n.vd-lsearch--sm {\n  height: 38px;\n}\n\n.vd-lsearch--sm input {\n  font-size: 13px;\n}\n\n/* Tooltip */\n.vd-tipwrap {\n  position: relative;\n  display: inline-flex;\n}\n\n.vd-tipwrap::after {\n  content: attr(data-tip);\n  position: absolute;\n  z-index: 90;\n  left: 50%;\n  transform: translateX(-50%) translateY(4px);\n  background: var(--vd-ink);\n  color: #fff;\n  font-size: 11.5px;\n  font-weight: 500;\n  padding: 6px 9px;\n  border-radius: 7px;\n  white-space: nowrap;\n  pointer-events: none;\n  opacity: 0;\n  transition: opacity .12s .25s, transform .12s .25s;\n  box-shadow: 0 6px 18px rgba(0,0,0,.18);\n}\n\n.vd-tipwrap--bottom::after {\n  top: 100%;\n}\n\n.vd-tipwrap--top::after {\n  bottom: 100%;\n  transform: translateX(-50%) translateY(-4px);\n}\n\n.vd-tipwrap:hover::after {\n  opacity: 1;\n  transform: translateX(-50%) translateY(8px);\n}\n\n.vd-tipwrap--top:hover::after {\n  opacity: 1;\n  transform: translateX(-50%) translateY(-8px);\n}\n\n/* Toast */\n.vd-wtoast {\n  position: fixed;\n  bottom: 24px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  padding: 11px 18px;\n  background: var(--vd-ink);\n  color: #fff;\n  border-radius: 11px;\n  font-size: 13.5px;\n  font-weight: 500;\n  box-shadow: 0 10px 30px rgba(0,0,0,.25);\n  z-index: 200;\n  animation: vd-toastin .2s ease;\n}\n\n.vd-wtoast svg {\n  color: #5FD0A0;\n}\n\n@keyframes vd-toastin {\n  from { opacity: 0; transform: translateX(-50%) translateY(8px); }\n  to { opacity: 1; transform: translateX(-50%) translateY(0); }\n}\n\n/* Input field */\n.vd-winput {\n  height: 44px;\n  padding: 0 14px;\n  border: 1px solid var(--vd-line);\n  border-radius: 10px;\n  background: var(--vd-surface);\n  font-family: inherit;\n  font-size: 14.5px;\n  color: var(--vd-ink);\n  outline: none;\n  transition: border-color .13s;\n}\n\n.vd-winput:focus {\n  border-color: var(--vd-blue-200);\n}\n\n.vd-winput--mono {\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 13.5px;\n}\n\n/* Field wrapper */\n.vd-wfield {\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n  margin-bottom: 16px;\n}\n\n.vd-wfield__lbl {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--vd-muted);\n}\n\n.vd-wfield__tag {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: .05em;\n  text-transform: uppercase;\n  color: var(--vd-amber);\n  background: var(--vd-amber-bg);\n  padding: 2px 7px;\n  border-radius: 999px;\n  margin-left: 6px;\n}\n\n.vd-wfield__box {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  padding: 11px 13px;\n  background: var(--vd-line-soft);\n  border-radius: 10px;\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 14px;\n  color: var(--vd-ink);\n}\n\n.vd-wfield__box svg {\n  color: var(--vd-blue-500);\n  flex: none;\n}\n\n.vd-wfield__hint {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: var(--vd-muted-2);\n}\n\n.vd-wfield__hint svg {\n  color: var(--vd-blue-500);\n}\n\n/* Button */\n.vd-ebtn {\n  height: 44px;\n  padding: 0 18px;\n  border-radius: 11px;\n  border: 1px solid var(--vd-line);\n  background: var(--vd-surface);\n  color: var(--vd-ink);\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  transition: all .13s;\n}\n\n.vd-ebtn--ghost:hover {\n  background: var(--vd-line-soft);\n}\n\n.vd-ebtn--primary {\n  background: var(--vd-blue-600);\n  border-color: var(--vd-blue-600);\n  color: #fff;\n  box-shadow: 0 2px 8px rgba(28,107,176,.28);\n}\n\n.vd-ebtn--primary:hover {\n  background: var(--vd-blue-700);\n}\n\n.vd-ebtn--danger {\n  background: var(--vd-danger-bg);\n  border-color: transparent;\n  color: var(--vd-danger);\n}\n\n.vd-ebtn--danger:hover {\n  background: var(--vd-danger);\n  color: #fff;\n}\n\n.vd-ebtn--grow {\n  flex: 1;\n}\n\n.vd-ebtn--icon {\n  width: 48px;\n  padding: 0;\n  flex: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
